import { render, staticRenderFns } from "./TableBase.vue?vue&type=template&id=2c70eb02&"
import script from "./TableBase.vue?vue&type=script&lang=ts&"
export * from "./TableBase.vue?vue&type=script&lang=ts&"
import style0 from "./TableBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c70eb02')) {
      api.createRecord('2c70eb02', component.options)
    } else {
      api.reload('2c70eb02', component.options)
    }
    module.hot.accept("./TableBase.vue?vue&type=template&id=2c70eb02&", function () {
      api.rerender('2c70eb02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboards/TableBase.vue"
export default component.exports